import { height } from './modules/height';
import { hamburger } from './modules/hamburger';
import { mvslide } from './modules/mvslide';
import { loading } from './modules/loading';
import { smoothscroll } from './modules/smoothscroll';
import { scrollmagic } from './modules/scrollmagic';
import { headerbtn } from './modules/headerbtn';
import { messageSlide } from './modules/messageSlide';
import { messageBtn } from './modules/messageBtn';

window.addEventListener('load', () => {
  //scrollに応じてアニメーションしたい時
  　scrollmagic();
  
    //crollによる処理を間引きしたい時
  　//scrollAction();
});


height();
hamburger();
mvslide();
loading();
smoothscroll();
headerbtn();
messageSlide();
messageBtn();
